import "./application/theme/react-quill.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppProvider } from "./presentation/core/providers/AppProvider";
import { HelmetProvider } from "react-helmet-async";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <React.StrictMode>
  <HelmetProvider>
    <AppProvider>
      <App />
    </AppProvider>
  </HelmetProvider>
  // </React.StrictMode>
);
